import Web3Modal from "web3modal";
import {ethers} from "ethers";
import NFT from "../../../contracts/NFT.json";

export async function approveMarketplaceAsManager(nftaddress: string, marketplaceaddress: string, tokenID: string) {
    const web3Modal = new Web3Modal()
    const connection = await web3Modal.connect()
    const provider = new ethers.providers.Web3Provider(connection)
    const signer = provider.getSigner()
    /* then list the item for sale on the marketplace */
    let contract = new ethers.Contract(nftaddress, NFT.abi, signer)
    console.log(nftaddress, marketplaceaddress, tokenID)
    return await contract.approve(marketplaceaddress, tokenID)
}